/* ODDFISH CASE STUDIES — button hover only; strikes handled by oddfish-home-strikes.js */

(function () {
  "use strict";

  function initSection(section) {
    if (!section || section.dataset.oddfishCaseBound === "1") return;
    section.dataset.oddfishCaseBound = "1";

    section.querySelectorAll(".oddfish-case-black-btn").forEach(function (btn) {
      btn.addEventListener("mouseenter", function () {
        this.classList.add("is-hovered");
      });
      btn.addEventListener("mouseleave", function () {
        this.classList.remove("is-hovered");
      });
    });
  }

  function bootAll(root) {
    if (root) {
      var section =
        root.classList && root.classList.contains("oddfish-case-section")
          ? root
          : root.querySelector(".oddfish-case-section");
      if (section) initSection(section);
      return;
    }

    document.querySelectorAll(".oddfish-case-section").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootAll();
    });
  } else {
    bootAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector(".oddfish-case-section");
    if (section) {
      delete section.dataset.oddfishCaseBound;
      initSection(section);
    }
  });
})();
